import { z } from 'zod';

export const InviteOrganizationUserBodySchema = z
  .object({
    email: z.email(),
    fullName: z.string().min(1),
    permissionGroupId: z.uuid(),
    scopeType: z.enum(['TENANT', 'PLACE']),
    placeId: z.uuid().optional(),
  })
  .refine((value) => value.scopeType === 'TENANT' || value.placeId !== undefined, {
    message: 'placeId is required when scopeType is PLACE',
    path: ['placeId'],
  });

export type InviteOrganizationUserBody = z.infer<typeof InviteOrganizationUserBodySchema>;

export const InviteOrganizationUserResponseSchema = z.object({
  outcome: z.enum(['INVITE_ISSUED', 'ACCESS_GRANTED']),
  inviteId: z.uuid().nullable(),
  userAccessId: z.uuid().nullable(),
});

export type InviteOrganizationUserResponse = z.infer<typeof InviteOrganizationUserResponseSchema>;
